import React from 'react';
import '../less/credit-line.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import { creditLineTariffsLink } from '../../../../../services/urls/urls';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import { Preloader } from 'MWComponents';
import additionalCards from '../enums/additional_cards_data.json';
import tariffs_data from '../enums/tariffs_data.json';
import tariffs_data_comission from '../enums/tariffs_data_comission.json';
import hero_data from '../enums/hero_data.json';
import { getUrl } from "utils/corploansUrl";
import advantagesItemsData from '../enums/advantages_items.json';
import award_img from '../img/award_img.svg';
import { businessAllCreditProductAwardLink } from '../../../../../services/urls/urls';
import CalculatorNew from '../../../../../auxiliary-components/CalculatorNew';

export default function template() {
    const page = 'credit-line-new';

    const model = this.getModel();

    const openCorploansLink = () => window.open(getUrl('loanline'));

    const awardBannerData = {
      link: businessAllCreditProductAwardLink,
      img: award_img,
      title: 'BUSINESS_CREDIT_LINE_BANNER_AWARDS_TITLE',
      text: 'BUSINESS_CREDIT_LINE_BANNER_AWARDS_TEXT'
    }
    const imagesMap = {
      advantages_img_1,
      advantages_img_2,
      advantages_img_3
    };

    const handlersMap = {
      openCorploansLink: openCorploansLink,
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const advantagesItems = advantagesItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    return (
        <div className="credit-line-new">
          <Hero
            data={heroData}
            img={hero_img}
            page={page}
            award={awardBannerData}
          />
          <div className="content">
            <Advantages
              items={advantagesItems}
              title={'BUSINESS_CREDIT_LINE_NEW_ADVANTAGES_TITLE'}
            />
            <div>
              <Tariffs
                title={'BUSINESS_CREDIT_LINE_NEW_CARDS_TARIFFS_TITLE'}
                items={tariffs_data}
              />
              <Tariffs
                items={tariffs_data_comission}
                title={'BUSINESS_CREDIT_LINE_NEW_CARDS_TARIFFS_COMISSION_TITLE'}
                btnLink={creditLineTariffsLink}
                btnText={'BUSINESS_CREDIT_LINE_NEW_CARDS_TARIFFS_BTN'}
                page={page}
              />
            </div>
            {model.creditSum ? (
              <CalculatorNew model={model} type={"credline"} {...this.props} page={page} onBtnClick={openCorploansLink} mode={model.mode}/>
            ) : <Preloader />}
            <AdditionalProduct
              items={additionalCards}
              title={'BUSINESS_CREDIT_LINE_NEW_ADDITIONAL_PRODUCT_TITLE'}
              page={page}
            />
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              loader={this.state.loader}
            />
          </div>
        </div>
    );
}
